import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

import { computed, type PropType } from 'vue';
import { Form, Col } from 'ant-design-vue';
import { useFormContext } from '../hooks/useFormContext';
import type { ColEx } from '../types/component';
import { Button, ButtonProps } from '@/components/basic/button';
import { BasicArrow } from '@/components/basic/basic-arrow';
import { useI18n } from '@/hooks/useI18n';

type ButtonOptions = Partial<ButtonProps> & { text: string };



export default /*@__PURE__*/_defineComponent({
  __name: 'form-action',
  props: {
  showActionButtonGroup: {
    type: Boolean,
    default: true,
  },
  showResetButton: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  showAdvancedButton: {
    type: Boolean,
    default: true,
  },
  resetButtonOptions: {
    type: Object as PropType<ButtonOptions>,
    default: () => ({}),
  },
  submitButtonOptions: {
    type: Object as PropType<ButtonOptions>,
    default: () => ({}),
  },
  actionColOptions: {
    type: Object as PropType<Partial<ColEx>>,
    default: () => ({}),
  },
  actionSpan: {
    type: Number,
    default: 6,
  },
  isAdvanced: Boolean,
  hideAdvanceBtn: Boolean,
},
  emits: ['toggle-advanced'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { t } = useI18n();
const { resetFields, submit } = useFormContext();
const actionColOpt = computed(() => {
  const { showAdvancedButton, actionSpan: span, actionColOptions, showResetButton, showSubmitButton } = props;
  const actionSpan = 24 - span;
  const advancedSpanObj = showAdvancedButton ? { span: actionSpan < 6 ? 24 : actionSpan } : {};
  const actionColOpt: Partial<ColEx> = {
    style: { textAlign: 'right' },
    span: showAdvancedButton ? 6 : (showResetButton && showSubmitButton ? 4 : 0),
    ...advancedSpanObj,
    ...actionColOptions,
  };
  return actionColOpt;
});

const getResetBtnOptions = computed((): ButtonOptions => {
  return Object.assign(
    {
      text: t('common.resetText'),
    },
    props.resetButtonOptions,
  );
});

const getSubmitBtnOptions = computed(() => {
  return Object.assign(
    {
      text: t('common.queryText'),
    },
    props.submitButtonOptions,
  );
});

function toggleAdvanced() {
  emit('toggle-advanced', props.isAdvanced);
}

return (_ctx: any,_cache: any) => {
  return (__props.showActionButtonGroup)
    ? (_openBlock(), _createBlock(_unref(Col), _normalizeProps(_mergeProps({ key: 0 }, actionColOpt.value)), {
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: _normalizeStyle([{"width":"100%"}, { textAlign: actionColOpt.value.style.textAlign }])
          }, [
            _createVNode(_unref(Form).Item, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "resetBefore"),
                (__props.showResetButton)
                  ? (_openBlock(), _createBlock(_unref(Button), _mergeProps({
                      key: 0,
                      type: "default",
                      class: "mr-2"
                    }, getResetBtnOptions.value, {
                      onClick: _unref(resetFields),
                      size: "small"
                    }), {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getResetBtnOptions.value.text), 1)
                      ]),
                      _: 1
                    }, 16, ["onClick"]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "submitBefore"),
                (__props.showSubmitButton)
                  ? (_openBlock(), _createBlock(_unref(Button), _mergeProps({
                      key: 1,
                      type: "primary",
                      class: "mr-2"
                    }, getSubmitBtnOptions.value, {
                      onClick: _unref(submit),
                      size: "small"
                    }), {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getSubmitBtnOptions.value.text), 1)
                      ]),
                      _: 1
                    }, 16, ["onClick"]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "advanceBefore"),
                (__props.showAdvancedButton && !__props.hideAdvanceBtn)
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 2,
                      type: "link",
                      size: "small",
                      onClick: toggleAdvanced
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.isAdvanced ? _unref(t)('component.form.putAway') : _unref(t)('component.form.unfold')) + " ", 1),
                        _createVNode(_unref(BasicArrow), {
                          class: "ml-1",
                          expand: !__props.isAdvanced
                        }, null, 8, ["expand"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "advanceAfter")
              ]),
              _: 3
            })
          ], 4)
        ]),
        _: 3
      }, 16))
    : _createCommentVNode("", true)
}
}

})